import {GetInitials} from 'app/shared/Common/Util'
import clsx from 'clsx'
import {FC, useEffect, useState} from 'react'

type UserSymbolProps = {
  className?: string
  alignment?: 'left' | 'right'
  position?: 'top' | 'bottom'
  variant?: string
  shape?: 'round' | 'square'
  size?: '35' | '100'
  name: string
  description?: string
  hideSymbol?: boolean
  hideText?: boolean
  truncate?: boolean
}

const UserSymbol: FC<UserSymbolProps> = ({
  className,
  alignment,
  position,
  variant,
  shape,
  size,
  name,
  description,
  hideSymbol,
  hideText,
  truncate,
}) => {
  const [initials, setInitials] = useState<string>()

  useEffect(() => {
    setInitials(GetInitials(name))
  }, [name])

  return (
    <>
      <div
        className={clsx(`d-flex gap-3 ${className}`, {
          'flex-row-reverse': alignment == 'right',
          'overflow-hidden': truncate,
        })}
      >
        <div
          className={clsx(`symbol symbol-${size}px`, {
            'd-none': hideSymbol,
            'symbol-circle': shape == 'round',
          })}
        >
          <span className={`symbol-label bg-${variant} text-inverse-${variant} fw-bolder`}>{initials}</span>
        </div>
        <div
          className={clsx('d-sm-flex flex-column justify-content-center', {
            'd-none ': hideText,
            'flex-column-reverse': position == 'bottom',
            'align-items-start': alignment == 'left',
            'align-items-end': alignment == 'right',
            'overflow-hidden': truncate,
          })}
        >
          <div
            title={name}
            className={clsx('text-dark fs-base fw-bolder lh-1', {
              'mb-2': position == 'top',
              'text-truncate w-100': truncate,
            })}
          >
            {name}
          </div>
          <div
            title={description}
            className={clsx('text-muted fs-7 fw-semibold lh-1', {
              'mb-2': position == 'bottom',
              'text-truncate w-100': truncate,
            })}
          >
            {description ?? '\u00a0'}
          </div>
        </div>
      </div>
    </>
  )
}

UserSymbol.defaultProps = {
  alignment: 'left',
  position: 'top',
  variant: 'primary',
  shape: 'round',
  size: '35',
  hideSymbol: false,
  hideText: false,
}

export default UserSymbol
